<template>
  <div class="main-content costPrice">
    <scrollTop>
      <i class="icon-fa icon-fa-arrow-up"></i>
    </scrollTop>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">

            <div class="row sticky">
              <div class="col-md-8">
                <DrugSearchNew
                  :onSelect="selectDrug"
                />
              </div>
              <div class="col-md-4 flex">
                <button @click="hideOrders = !hideOrders" class="btn btn-default">
                  {{ hideOrders ? 'Показать' : 'Скрыть' }} заявки
                </button>
                <vue-ladda @click="getHistory()" button-class="p-l-5 btn btn-info"
                           data-style="zoom-in"
                           :loading="btn_loading">Показать
                </vue-ladda>
              </div>
            </div>

            <table v-if="records" class="table table-hover">
              <tbody>
              <tr>
                <td>Начальное количество: <strong>{{ qty }}</strong></td>
                <td>Начальная стоимость: <strong>{{ cost }}</strong></td>
              </tr>

              <tr v-for="(order) in beforeInvoice" v-if="!hideOrders">
                <td><strong>{{ order.id }}</strong>: {{ order.date }}
                </td>
                <td>Количество: <strong>{{ order.qty }}</strong></td>
              </tr>

              <tr>
                <td colspan="2">
                  Всего продано за период: <strong>{{ preSold }}</strong> по <strong>{{ cost }} EUR</strong> остаток
                  <strong>{{ qty - preSold }}</strong>
                </td>
              </tr>

              <template v-for="(record, index) in records">
                <tr class="invoice_tr">
                  <td>
                    <p>Инвойс: № <strong>{{ record.invoice.id }}</strong> дата: {{ record.invoice.date }}
                      <button @click="showInvoice(record.invoice.id)" class="btn btn-xs btn-info smallModalBtn">
                        <i class="icon-fa icon-fa-eye"></i>
                      </button>
                    </p>
                    <p>Валюта: <strong>{{ record.invoice.currency }}</strong></p>
                    <p>Количество: <strong>{{ record.invoice.qty }}</strong></p>
                  </td>
                  <td>
                    <p>Курс: <strong>{{ record.invoice.euro_rate }}</strong></p>
                    <p>Стоимость: <strong>{{ record.invoice.price }}</strong> Стоимость без скидки:
                      <strong>{{ record.invoice.income_price }}</strong></p>
                    <p><span v-if="record.invoice.currency !== 'EUR'">EUR:
                      <strong>{{ Math.round(record.invoice.price * record.invoice.euro_rate * 10000) / 10000 }}</strong>
                      на сумму <strong>{{
                          Math.round(record.invoice.price * record.invoice.euro_rate * record.invoice.qty * 10000) / 10000
                        }}</strong>
                      </span>
                    </p>
                  </td>
                </tr>
                <tr class="cost_tr">
                  <td>Себестоимость: <strong>{{ record.drug.cost }}</strong></td>
                  <td>Количество: <strong>{{ record.drug.qty }}</strong> на сумму
                    <strong>{{ Math.round(record.drug.qty * record.drug.cost * 1000) / 1000 }}</strong></td>
                </tr>
                <template v-for="(orders) in record.orders" v-if="!hideOrders">
                  <tr v-for="(order) in orders" v-bind:class="{ 'writeOff_tr': order.invoice }">
                    <td>
                      <button
                        @click="orderToEdit(order.id)"
                        class="btn btn-xs btn-info ml-1 mr-2"
                      >
                        <i class="icon-fa icon-fa-eye"></i>
                      </button>
                      <template v-if="order.invoice">
                        Списание: № <strong>{{ order.id }}</strong> : {{ order.date }}
                      </template>
                      <template v-else>
                        № <strong>{{ order.id }}</strong> : {{ order.date }}
                      </template>
                    </td>
                    <td>
                      Количество: <strong>{{ order.qty }}</strong>
                      <span v-if="order.minus_error">ОШИБКА - выход в минус</span>
                    </td>
                  </tr>
                </template>
                <tr>
                  <td colspan="2">
                    Всего продано за период: <strong>{{ record.sold }}</strong> по <strong>{{ record.drug.cost }}
                    EUR</strong> остаток <strong>{{ record.drug.qty - record.sold }}</strong>
                    <span
                      v-if="record.drug.qty - record.sold">на сумму <strong>{{
                        Math.round((record.drug.qty - record.sold) * record.drug.cost * 10000) / 10000
                      }}</strong></span>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import api from '@/api';
import VueLadda from 'vue-ladda/src/vue-ladda.vue';
import * as _ from 'lodash';
import scrollTop from "../../components/scrollTop";
import DrugSearchNew from "@/components/drugs/DrugSearchNew";

export default {
  components: {
    scrollTop,
    VueLadda,
    DrugSearchNew,
  },
  data() {
    return {
      hideOrders: true,
      selectedDrug: null,
      options: [],
      cost: 0,
      qty: 0,
      records: null,
      beforeInvoice: null,
      drugId: null,
      btn_loading: false,
      preSold: 0,
    }
  },
  mounted() {
    // this.uploadFile();
  },
  methods: {
    selectDrug(e) {
      this.selectedDrug = e;
      this.records = null;
    },
    orderToEdit(id, dialog = null) {
      this.$store.dispatch('orders/setOrderToEdit', {orderId: id});
    },
    onSearch(search, loading) {
      if (!search) return;
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      fetch(
        // `https://api.github.com/search/repositories?q=${escape(search)}`
        `/api/noa/getDrugByNameMorion?search=${encodeURIComponent(search)}`
      ).then(res => {
        res.json().then(json => (vm.options = json.items));
        loading(false);
      });
    }, 350),
    showInvoice(id) {
      this.$store.dispatch('platform/setGlobalDrawerData', {
        data: {type: 'editInvoice', invoiceId: id},
        // callBackAction: () => this.getRecords()
      });
    },
    async getHistory() {

      if (!this.selectedDrug) return;

      this.records = null;
      this.btn_loading = true;
      let {data} = await api.post('/invoices/getHistory', {
        drugId: this.selectedDrug.id
      });

      this.records = data.records;
      this.beforeInvoice = data.beforeInvoice;
      this.cost = data.start_cost;
      this.qty = data.start_qty;
      this.preSold = data.pre_sold;

      this.btn_loading = false;
    }
  }
}
</script>

<style>
.costPrice .vs__dropdown-option--highlight,
.costPrice .vs__dropdown-option {
  width: fit-content;
  /*overflow: visible;*/
}

.costPrice .vs__dropdown-option--highlight div {
  /*background-color: #5897fb;*/
  /*overflow: visible;*/
}
</style>

<style scoped>
.sticky {
  position: sticky;
  top: 60px;
  background-color: white;
  padding: 15px 0;
}

.invoice_tr {
  background-color: #f4f4ff;
}

.cost_tr {
  background-color: #eaffea;
}

.writeOff_tr {
  background-color: #ffeaea;
}
</style>
